import { render, staticRenderFns } from "./base-layout.vue?vue&type=template&id=7402df42&scoped=true"
import script from "./base-layout.vue?vue&type=script&lang=js"
export * from "./base-layout.vue?vue&type=script&lang=js"
import style0 from "./base-layout.vue?vue&type=style&index=0&id=7402df42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7402df42",
  null
  
)

export default component.exports